
































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class WorkExperience extends Vue {
  years = [
          {
            color: 'cyan',
            year: 'Jul 2016 - Now',
            position: 'Co-Founder & Chief Technology Officer (CTO)',
            company: 'byte heroes GmbH',
            description: 'As founder and CTO of byte heroes GmbH I created the first crypto currency of Austria and was responsible for the implementation of the first legal ICO (Initial Coin Offering) of Austria and one of the first legal ICOs in Europe. Additionally I implemented the infrastructure, backend and frontend of our product herosphere.gg with more than 300k users. Together with my Co-Founder I lead the company with more than 20 employees as general manager.'
          },
          {
            color: 'green',
            year: 'Oct 2013 - Oct 2015',
            position: 'Solution Architect',
            company: 'exthex GmbH',
            description: 'Software Development in the field of E-Government, eHealth and AAL (Ambient Assisted Living). Project Management, Business Development Java and Andriod Development'
          },
          {
            color: 'pink',
            year: 'Feb 2013 - Sep 2013',
            position: 'Internship (Master thesis)',
            company: 'T-Systems',
            description: 'Development of a generic system architecture to generate ELGA CDA-documents out of existing data in Hospital Information Systems. Develpment of a prototype for the HIS "i.s.h.med". Master Thesis'
          },
          {
            color: 'amber',
            year: 'Jul 2012 - Dec 2012',
            position: 'Scientific Assistant',
            company: 'University of Applied Science "FH Joanneum"',
            description: 'Supervision of the european project "PALANTE" and the module "X-ray record". Development of a system which collects and visualizes the radiation exposure of patients during radiological examinations. Requirements analysis and implementation of a prototype for the online access to this data.'
          },
          {
            color: 'orange',
            year: 'Aug 2010 - Jul 2012',
            position: 'Software Developer, Analyst',
            company: 'Ludwig Boltzmann Institute',
            description: 'Analysis of the data, document and knowledge management. Implementation of an interactive web based knowledge database.'
          }
          ];
}
